<template>

	<el-container>
		<el-header>
			<el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">单个新增</el-button>
			<el-input v-model="select_word" @input="FindTextChange()" placeholder="姓名查找" style="float: left;display:inline-block;width:200px;"></el-input>
			<el-popover style="float: left;">
				<a slot="reference" :href="ExportUrl" target="_blank" @click="ExportCus">
					<el-button style="margin:0px 5px 0px 8px;" type="primary" >导出人员名单</el-button>
				</a>
			</el-popover>

		</el-header>
		<el-main>
			<el-tabs v-model="curgrpupid" @tab-click="tabhandleClick">
			<el-tab-pane v-for="grp in ordergrouplist" :label="grp.GroupName" :name="grp.GroupID" :key="grp.GroupName">
				<el-table border ref="multipleTable" tooltip-effect="dark" :data="getGroupCus(grp.GroupID).slice((currentPage-1)*pagesize,currentPage*pagesize)">
					<el-table-column prop="cusname" label="姓名" width="160px"></el-table-column>
					<el-table-column prop="cussex" label="适用性别" width="100px">
						<template slot-scope="scope">
							<div v-for="item in AdaptSex">
								<label v-if='scope.row.cussex==item.value'>{{item.key}}</label>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="cusmarry" label="婚否" width="60px">
						<template slot-scope="scope">
							<div v-for="item1 in AdaptMarry">
								<label v-if='scope.row.cusmarry==item1.value'>{{item1.key}}</label>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="cusbirthday" label="出生日期"></el-table-column>
					<el-table-column prop="mobile" label="手机号"></el-table-column>
					<el-table-column prop="idcard" label="证件号"></el-table-column>
					<el-table-column prop="cusstatus" label="状态" width="100px">
						<template slot-scope="scope">
							<div v-for="item1 in CusStatus">
								<label v-if='scope.row.cusstatus==item1.value'>{{item1.key}}</label>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="memo" label="备注"></el-table-column>
					<el-table-column label="操作" width="200px">
						<!-- fixed="right" -->
						<template slot-scope="scope">
							<el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="text" size="small">编辑</el-button>
							<el-button @click="handleDelete(scope.$index, scope.row)" icon="el-icon-circle-close" type="text" size="small">删除</el-button>

						</template>
					</el-table-column>
				</el-table>
				<el-footer style="margin-top:20px;">
					<template>
						<div class="block">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
							 :page-sizes="[10, 20, 40,80]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="getGroupCus(grp.GroupID).length"></el-pagination>
						</div>
					</template>
				</el-footer>
			</el-tab-pane>
		</el-tabs>

		</el-main>
		
		<el-dialog width="480px" title="修改信息" :visible.sync="bao1edit">
			<el-form style="width: 400px;text-align: left;" label-width="120px" :model="EditInfo" ref="EditInfo">
				<el-form-item label="姓名">
					<el-input v-model="EditInfo.cusname"></el-input>
				</el-form-item>
				<el-form-item label="性别" required>
					<el-radio v-model="EditInfo.cussex" label="1">男</el-radio>
					<el-radio v-model="EditInfo.cussex" label="2">女</el-radio>
				</el-form-item>
				<el-form-item label="婚否" required>
					<el-radio-group size="mini" v-model="EditInfo.cusmarry">
						<el-radio-button :label="1">已婚</el-radio-button>
						<el-radio-button :label="2">未婚</el-radio-button>
					</el-radio-group>
					<!-- <el-select size="mini" v-model="EditInfo.cusmarry">
						<el-option v-for="item in this.$enums.Marry" :label="item.key" :value="item.value" placeholder="请选择">
							{{ item.key }}
						</el-option>
					</el-select> -->
				</el-form-item>
				<el-form-item label="出生日期"  required>
					<el-date-picker type="date" size="mini" v-model="EditInfo.cusbirthday" format="yyyy-MM-dd"></el-date-picker>
					<!-- <el-input  type='date' ></el-input> -->
				</el-form-item>
				<!-- <el-form-item label="性别">
					<el-select style=" width: 80px;  height:30px;" v-model="EditInfo.cussex">
						<el-option v-for="item in this.$enums.Sex" :label="item.key" :value="item.value" placeholder="请选择">
							{{ item.key }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="婚否">
					<el-select style=" width: 80px;  height:30px;" v-model="EditInfo.cusmarry">
						<el-option v-for="item in this.$enums.Marry" :label="item.key" :value="item.value" placeholder="请选择">
							{{ item.key }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="cusbirthday">
					<el-input type='date' v-model="EditInfo.cusbirthday"></el-input>
				</el-form-item> -->
				<el-form-item label="手机">
					<el-input v-model="EditInfo.mobile"></el-input>
				</el-form-item>
				<el-form-item label="身份证号">
					<el-input v-model="EditInfo.idcard"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="EditInfo.memo"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1editSure">确定</el-button>
					<el-button @click.native="bao1edit = false">取消</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>

		<!-- ----新增信息---- -->
		<el-dialog width="480px"  title="新增信息" :visible.sync="bao1newadd" v-dialogDrag>
			<el-form style="width: 400px;text-align: left;"label-width="120px" :model="AddInfo" ref="AddInfo" >
				<el-form-item label="分组" required>
					<el-select style=" width: 280px;  height:30px;" v-model="AddInfo.groupid" placeholder="请选择">
						<el-option v-for="item in ordergrouplist" :label="item.GroupName" :value="item.GroupID">
							{{ item.GroupName }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="姓名" required>
					<el-input v-model="AddInfo.cusname"></el-input>
				</el-form-item>
				<el-form-item label="性别" required>
					<el-radio v-model="AddInfo.cussex" label="1">男</el-radio>
					<el-radio v-model="AddInfo.cussex" label="2">女</el-radio>
				</el-form-item>
				<el-form-item label="婚否" required>
					<el-radio-group size="mini" v-model="AddInfo.cusmarry">
						<el-radio-button :label="1">已婚</el-radio-button>
						<el-radio-button :label="2">未婚</el-radio-button>
					</el-radio-group>
					<!-- <el-select size="mini" v-model="EditInfo.cusmarry">
						<el-option v-for="item in this.$enums.Marry" :label="item.key" :value="item.value" placeholder="请选择">
							{{ item.key }}
						</el-option>
					</el-select> -->
				</el-form-item>
				<!-- <el-form-item label="性别">
					<el-select style=" width: 80px;  height:30px;" v-model="AddInfo.cussex" placeholder="请选择">
						<el-option v-for="item in this.$enums.Sex" :label="item.key" :value="item.value">
							{{ item.key }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="婚否">
					<el-select style=" width: 80px;  height:30px;" v-model="AddInfo.cusmarry" placeholder="请选择">
						<el-option v-for="item in this.$enums.Marry" :label="item.key" :value="item.value">
							{{ item.key }}
						</el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label="出生日期" required>
					<el-date-picker type="date" size="mini" v-model="AddInfo.cusbirthday" format="yyyy-MM-dd"></el-date-picker>
					
				</el-form-item>
				<el-form-item label="手机" required>
					<el-input v-model="AddInfo.mobile"></el-input>
				</el-form-item>
				<el-form-item label="身份证号">
					<el-input v-model="AddInfo.idcard" @blur='idcardonblur'></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="AddInfo.memo"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
					<el-button @click.native="bao1newadd = false">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>



	</el-container>
</template>

<script>
	import ordercus from '../../apifunction/OrderCus.js'
	import ordergroup from '../../apifunction/OrderGroup.js'
	import checkidcard from '../../commontools/checkIDcard.js'
	export default {
		created() {
			this.initData()
		},
		data() {
			return {
				orderent: this.inorder,
				ordergrouplist: [],
				cusAllList: [],
				cuslist: [],
				AdaptSex: this.$enums.AdaptSex,
				AdaptMarry: this.$enums.AdaptMarry,
				CusStatus: this.$enums.CusStatus,
				ExportUrl: '',
				currentPage: 1,
				pagesize: 10,
				curgrpupid: '',
				bao1edit: false,
				bao1newadd: false,
				select_word: "",
				idx: null,
				EditInfo: {
					id: '',
					cusname: '',
					cussex: '1',
					cusbirthday: '',
					cusmarry: '3',
					mobile: '',
					idcard: '',
					cusstatus: '10',
					memo: '',
					orderid: '',
					groupid: '',
					corpid: ''
				},
				AddInfo: {
					id: '',
					cusname: '',
					cussex: '1',
					cusbirthday: '',
					cusmarry: '0',
					mobile: '',
					idcard: '',
					cusstatus: '10',
					memo: '',
					orderid: '',
					groupid: '',
					corpid: ''
				}

			}
		},
		watch: {
			"$route": "initData"
		},
		props: ['inorder'],
		computed: {
			data() {
				return this.cuslist.filter(item => {

					if (item.cusname.indexOf(this.select_word) > -1) {
						return item;
					}
				});
			}
		},
		methods: {
			initData() {
				//alert(JSON.stringify(this.orderent))
				ordergroup.GetOrderGroupData(this.orderent.OrderID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.ordergrouplist = JSON.parse(ent.Data);
								this.curgrpupid = this.ordergrouplist[0].GroupID;
								ordercus.GetOrderCusByOrder(this.orderent.OrderID)
									.then(res => {
										let ent = JSON.parse(JSON.stringify(res.data))
										if (ent.Flag == 'success') {
											if (ent.Data != 'null') {
												this.cusAllList=JSON.parse(ent.Data);
												this.cuslist = JSON.parse(ent.Data);
											} else
												this.cuslist = [];
										} else
											this.$message.info(ent.Msg);
									});
							} else
								this.ordergrouplist = [];

						} else
							this.$message.info(ent.Msg);
					})
			},
			FindTextChange: function() {
				if (this.select_word == '') {
					this.cuslist = this.cusAllList;
					return;
				}
				//alert(py.chinesesToPY(this.SaleModuleListAll[0].SaleModuleName))
				var templist = this.cusAllList.filter(item => {
					if (item.cusname.indexOf(this.select_word) > -1) {
						//if (item.SaleModuleName.indexOf(this.txtFind) > -1) {
						return item
					}
				});
				this.cuslist = JSON.parse(JSON.stringify(templist));
			},
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			getGroupCus(groupid) {
				if (this.cuslist.length < 1)
					return [];
				return this.cuslist.filter(f => {
					if (f.groupid == groupid) {
						return f;
					}
				})
			},
			tabhandleClick() {
				this.pagesize = 10;
				this.currentPage = 1;
			},
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;

				this.EditInfo = {
					id: row.id,
					cusname: row.cusname,
					cussex: row.cussex,
					cusbirthday: row.cusbirthday,
					cusmarry: row.cusmarry,
					mobile: row.mobile,
					idcard: row.idcard,
					cusstatus: row.cusstatus,
					memo: row.memo,
					orderid: row.orderid,
					groupid: row.groupid,
					corpid: row.corpid
				};
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				// if(this.EditInfo.cusname==''||this.EditInfo.mobile=='')
				// {
				// 	this.$message.info("姓名、手机号不能空！");
				// 	return;
				// }
				// if(this.EditInfo.mobile.length!=11)
				// {
				// 	this.$message.info("请确认手机号是否填写正确！");
				// 	return;
				// }
				
				let grpent=this.ordergrouplist.find(v=>{return v.GroupID==this.EditInfo.groupid} );
				let msg=ordercus.CheckCusAndGrp(this.EditInfo,grpent);
				if(msg!='')
				{
					this.$message.info(msg);
					return;
				}
				this.EditInfo.cusbirthday=this.CommonFun.formatdate(this.EditInfo.cusbirthday)
				ordercus.EditCus(this.EditInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.cuslist.splice(this.idx, 1, this.EditInfo)
							this.bao1edit = false;
							this.$message.success("修改成功");

						} else
							this.$message.info(ent.Msg);
					})

			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
				this.AddInfo.cusname = '';
				this.AddInfo.cussex = '1';
				this.AddInfo.cusbirthday = this.CommonFun.GetDateByAddYears(new Date(),-20);
				this.AddInfo.cusmarry = '0';
				this.AddInfo.mobile = '';
				this.AddInfo.idcard = '';
				this.AddInfo.memo = '';
				this.AddInfo.groupid = this.curgrpupid;
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				//this.$refs.AddInfo 这个数据上有一个validate方法,这个方法可以判断数据是否存在
				if (this.AddInfo.GroupName == '') {
					this.$message.info("分组名称不能为空！");
					return;
				}
				if(this.AddInfo.cusname==''||this.AddInfo.mobile=='')
				{
					this.$message.info("姓名、手机号不能空！");
					return;
				}
				
				let grpent=this.ordergrouplist.find(v=>{ return v.GroupID==this.AddInfo.groupid  });
				let msg=ordercus.CheckCusAndGrp(this.AddInfo,grpent);
				if(msg!='')
				{
					this.$message.info(msg);
					return;
				}
				if(this.AddInfo.mobile.length!=11)
				{
					this.$message.info("请确认手机号是否填写正确！");
					return;
				}
				let user = this.$myglobal.getUserInfo();
				this.AddInfo.id = this.CommonFun.NewGuid();
				this.AddInfo.orderid = this.orderent.OrderID;
				this.AddInfo.corpid = user.corpid;
				this.AddInfo.cusbirthday=this.CommonFun.formatdate(this.AddInfo.cusbirthday)
				ordercus.AddCus(this.AddInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.cuslist.unshift(this.AddInfo);
							this.bao1newadd = false;
							this.$message.success("新增成功");

						} else
							this.$message.info(ent.Msg);
					})
			},
			handleDelete(index, row) {
				if (row.cusstatus != '10') {
					this.$message.success("只能删除‘名单导入’状态的客户");
					return;
				}
				this.$confirm('确定要删掉此客户信息吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(res => {
					ordercus.DelCus(row.id)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								this.initData();
								this.$message.warning("删除成功");
							} else {
								this.$message.info(ent.Msg);
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			idcardonblur(cardid) {
				checkidcard.checkCard(cardid);
				this.AddInfo.cusbirthday = checkidcard.baseInfo.birthday;
				this.AddInfo.cussex = checkidcard.baseInfo.sex;
				// this.baseInfo.birthday = birth;

			},
			ExportCus() {
				this.ExportUrl = ordercus.ExportOrderCusToExcel(this.orderent.OrderID)
				 // try {
				 //       const res = this.ExportUrl       // 接口未处理二进制
				 //       // const blob = new Blob([res.data], {
				 //       //   type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				 //       // })
				 
				 //       const downloadElement = document.createElement('a')
				 //       const href = window.URL.createObjectURL(res) // 创建下载的链接
				 //       downloadElement.href = href
				 //       downloadElement.download = '导出数据.xlsx' // 下载后文件名
				 //       document.body.appendChild(downloadElement)
				 //       downloadElement.click() // 点击下载
				 //       document.body.removeChild(downloadElement) // 下载完成移除元素
				 //       window.URL.revokeObjectURL(href) // 释放掉blob对象
				 //       if (res) {
				 //         this.$message({
				 //           type: 'success',
				 //           message: '下载成功'
				 //         })
				 //       }
				 //     } catch (err) {
				 //       console.warn(err)
				 //     }
			},


		}
	}
</script>

<style>
</style>
